<template>
  <div class="setting">
    <div class="title"><img src="../../assets/setting.png" /></div>
    <div class="content"><div class="contitle">获奖机构和产品有机会获得如下奖励：</div>
    <div>
      <div class="line">
        <img src="../../assets/1.png" />
        <span>东航金控十亿种子基金跟投；</span>
      </div>
      <div class="line">
        <img src="../../assets/2.png" />
        <span>东航金控、东航期货白名单准入资格；</span>
      </div>
      <div class="line">
        <img src="../../assets/3.png" />
        <span>入选东航金融推广渠道精选产品名单；</span>
      </div>
      <div class="line">
        <img src="../../assets/4.png" />
        <span>媒体宣传推广及基金经理专访；</span>
      </div>
      <div class="line">
        <img src="../../assets/5.png" />
        <span>参加线下资金对接会；</span>
      </div>
      <div class="line">
        <img src="../../assets/6.png" />
        <span>受邀参加“蓝海密剑”中国对冲基金公开赛颁奖典礼、年度策略闭门会议；</span>
      </div>
      <div class="line">
        <img src="../../assets/7.png" />
        <span>恒生子公司云纪网络全面系统服务（CBS），支持资产管理、风险控制等；</span>
      </div>
      <div class="line">
        <img src="../../assets/8.png" />
        <span>程序化产品有机会使用交易所机房托管服务，享受高速交易通道</span>
      </div>
    </div></div>
    <singup></singup>

  </div>
</template>
<script>
import singup from "../common/singup.vue"
export default {
  components:{
    singup
  }
}
</script>
<style scoped>
  .setting {
    height: 100%;
    background: url("../../assets/rulessettingbg.png") no-repeat center;
    background-size: cover;
    position: relative;
  }
  .title {
    text-align: center;
    padding-top: 10vh;
  }
  .title img {
    width: 43%;
  }
  .content {
    padding: 7vw 6vw 0 6vw;
  }
  .contitle {
    color: #86b6f8;
    font-size: 4vw;
    padding-bottom: 2vw;
  }
  .line {
    color: #fff;
    width: 84vw;
    padding-left: 6vw;
    font-size: 3.5vw;
    line-height: 6vw;
    padding-bottom: 3vw;
    position: relative;
  }
  .content img {
    width: 7vw;
    margin-right: 2vw;
    position: absolute;
    left: -1vw;
    top: -0.5vw;
  }
  .line span {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/setting.vue